// extracted by mini-css-extract-plugin
module.exports = {"header":"_40d5d0e87d--header--MOif3","controls":"_40d5d0e87d--controls--kM_l8"};